import { Component } from '@angular/core';

@Component({
    selector: 'app-dummy',
    templateUrl: './dummy.component.html',
    standalone: false,
})
export class DummyComponent {
    constructor() {}
}
